import React from "react";

export const Group1 = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={24}
      height={25}
      viewBox="0 0 24 25"
      fill="none"
      {...props}
    >
      <mask
        id="mask0_536_2329"
        style={{ maskType: "luminance" }}
        maskUnits="userSpaceOnUse"
        x={0}
        y={0}
        width={24}
        height={25}
      >
        <path d="M0 0.510254H24V24.5103H0V0.510254Z" fill="white" />
      </mask>
      <g mask="url(#mask0_536_2329)">
        <path
          d="M14.8571 16.8531C14.8571 16.2977 14.9664 15.7479 15.179 15.2349C15.3915 14.7218 15.7029 14.2557 16.0956 13.863C16.4882 13.4703 16.9544 13.1589 17.4674 12.9464C17.9805 12.7339 18.5303 12.6245 19.0856 12.6245C19.6409 12.6245 20.1908 12.7339 20.7038 12.9464C21.2169 13.1589 21.683 13.4703 22.0757 13.863C22.4683 14.2557 22.7798 14.7218 22.9923 15.2349C23.2048 15.7479 23.3142 16.2977 23.3142 16.8531H19.0856H14.8571Z"
          stroke="#3377FF"
          strokeWidth={2}
          strokeLinejoin="round"
        />
        <path
          d="M19.0854 12.6246C17.9177 12.6246 16.9711 11.678 16.9711 10.5103C16.9711 9.34259 17.9177 8.396 19.0854 8.396C20.2531 8.396 21.1997 9.34259 21.1997 10.5103C21.1997 11.678 20.2531 12.6246 19.0854 12.6246Z"
          stroke="#3377FF"
          strokeWidth={2}
        />
        <path
          d="M0.799925 16.8531C0.799925 16.2977 0.909298 15.7479 1.12183 15.2349C1.33434 14.7218 1.64579 14.2557 2.03846 13.863C2.4311 13.4703 2.89729 13.1589 3.4103 12.9464C3.92335 12.7339 4.47319 12.6245 5.02852 12.6245C5.58381 12.6245 6.13369 12.7339 6.6467 12.9464C7.15975 13.1589 7.6259 13.4703 8.01858 13.863C8.41122 14.2557 8.7227 14.7218 8.93521 15.2349C9.14771 15.7479 9.25708 16.2977 9.25708 16.8531H5.02852H0.799925Z"
          stroke="#3377FF"
          strokeWidth={2}
          strokeLinejoin="round"
        />
        <path
          d="M5.02829 12.6246C3.8606 12.6246 2.914 11.678 2.914 10.5103C2.914 9.34259 3.8606 8.396 5.02829 8.396C6.19598 8.396 7.14258 9.34259 7.14258 10.5103C7.14258 11.678 6.19598 12.6246 5.02829 12.6246Z"
          stroke="#3377FF"
          strokeWidth={2}
        />
        <path
          d="M5.14289 19.0246C5.14289 18.1241 5.32025 17.2324 5.66486 16.4005C6.00946 15.5686 6.51456 14.8126 7.15131 14.1759C7.78803 13.5391 8.54397 13.0341 9.37591 12.6894C10.2079 12.3448 11.0996 12.1675 12 12.1675C12.9005 12.1675 13.7922 12.3448 14.6242 12.6894C15.4561 13.0341 16.212 13.5391 16.8488 14.1759C17.4855 14.8126 17.9906 15.5686 18.3352 16.4005C18.6798 17.2324 18.8572 18.1241 18.8572 19.0246H12H5.14289Z"
          stroke="#4BCFFF"
          strokeWidth={2}
          strokeLinejoin="round"
        />
        <path
          d="M11.9999 12.1674C10.1063 12.1674 8.57132 10.6324 8.57132 8.73887C8.57132 6.84533 10.1063 5.3103 11.9999 5.3103C13.8934 5.3103 15.4285 6.84533 15.4285 8.73887C15.4285 10.6324 13.8934 12.1674 11.9999 12.1674Z"
          stroke="#4BCFFF"
          strokeWidth={2}
        />
      </g>
    </svg>
  );
};
